export enum SwapType {
  SWAP,
}

export default function SwapTab({ children }) {
  return children;
}
